export default __webpack_public_path__ + "static/media/next-earbuddyzultrapro.826cb36b.jpg";